import { ResponseWrapper, PagedResults, UserBasicDto, trackerGet, trackerPost, trackerDelete, trackerPatch, decodeResult } from "./basicApi.ts";

interface BeamlineDto {
  id: number;
  slug: string;
  name: string;
  description?: string;
  external_link?: string;
  ids_owners: number[];
  ids_watchers: number[];
}


interface BeamlineDetailsDto {
  id: number;
  slug: string;
  name: string;
  description?: string;
  external_link?: string;
  owners: UserBasicDto[];
  watchers: UserBasicDto[];
}


// Get a list of Beamlines the logged-in user has access to
async function getBeamlines(): Promise<ResponseWrapper<PagedResults<BeamlineDto>>> {
  const result = await trackerGet(`beamlines/`, {});
  return decodeResult(result);
}


async function getBeamlineDetailsBySlug(slug: string): Promise<ResponseWrapper<BeamlineDetailsDto>> {
  const result = await trackerGet(`beamlines/${slug}/details/`, {});
  return decodeResult(result);
}


export type { BeamlineDto, BeamlineDetailsDto };
export {  getBeamlines, getBeamlineDetailsBySlug }
